import moment from 'moment';

export const calendarRanges = {
  Today: [moment(), moment()],
  Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
  'This Month': [moment().startOf('month'), moment()],
  'Last Month': [
    moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month')
  ],
  'This Year': [moment().startOf('year'), moment()],
  'Last Year': [
    moment().subtract(1, 'year').startOf('year'),
    moment().subtract(1, 'year').endOf('year')
  ],
  'All Time': [
    moment('2014-01-01'),
    moment()
  ]
};
